export default __webpack_public_path__ + "static/media/neutral.b6cd7313.svg";